"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'BodyText',
    props: {
        cols: {
            type: Number,
            default: 1,
        },
    },
    setup(__props) {
        const props = __props;
        const colClass = props.cols === 2 ? 'lg:columns-2' : '';
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                class: (0, vue_2.normalizeClass)(["prose prose-lg max-w-none", (0, vue_2.unref)(colClass)])
            }, [
                (0, vue_2.renderSlot)(_ctx.$slots, "default")
            ], 2));
        };
    }
});
